import { styled } from '@mui/material'
import { memo } from 'react'
import { transientOptions } from '../../styles/TransientOptions'

export const TrendColorizerText = styled('span', transientOptions)<{
  $trend: boolean | null
}>`
  color: ${({ theme, $trend }) =>
    $trend === true
      ? theme.color.buy50
      : $trend === false
        ? theme.color.sell50
        : theme.color.text70};
`
export const TrendColorizer = memo<{
  trend?: boolean | null
  value: string
}>(({ trend, value }) => {
  if (trend === undefined) {
    if (Number(value) > 0) {
      trend = true
    } else if (Number(value) < 0) {
      trend = false
    } else {
      trend = null
    }
  }
  return <TrendColorizerText $trend={trend}>{value}</TrendColorizerText>
})
